export enum EXTERNAL_URL {
    REFERRAL_LINK = 'https://game.metapocket.games?referral=',
    FACEBOOK = 'https://www.facebook.com/',
    TWITTER = 'https://twitter.com/',
    DISCORD = 'https://discord.com/'
};